import React, { useEffect, useState } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../../firebase";
import TextField from "@mui/material/TextField";

function DropDownClientIdentifier(props) {
  const [allClients, setAllClients] = useState([]);
  const isFieldEmpty = (value) => {
    return value === "" || value === null || value === undefined;
  };

  useEffect(() => {
    const clientCollection = collection(db, "clients");
    const q = query(clientCollection);

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      setAllClients(
        querySnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            firstName: data.firstName,
            lastName: data.lastName,
            clientIdentifier: data.clientIdentifier,
          };
        })
      );
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleChange = (event) => {
    props.onChange(event.target.value);
  };

  const renderOptions = () => {
    allClients.sort((a, b) => a.firstName.localeCompare(b.firstName));
    return (
      <>
        <option value="">--Choose a client--</option>
        {allClients.map((client) => (
          <option key={client.id} value={client.clientIdentifier}>
            {`${client.clientIdentifier} (${client.firstName} ${client.lastName})`}
          </option>
        ))}
      </>
    );
  };

  return (
    <div className="input-label-container">
      <div className="input-label-dropdown">
        {props.title}
        {props.isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
      <TextField
        className="dropdown-select"
        style={{
          width: "200px",

          border:
            props.showValidation && isFieldEmpty(props.value)
              ? "1px solid red"
              : "none",
        }}
        SelectProps={{
          native: true,
          style: { height: 40 },
        }}
        select
        value={props.value}
        onChange={handleChange}
        error={props.showValidation && isFieldEmpty(props.value)} // Affiche l'erreur si vide
        helperText={
          props.showValidation && isFieldEmpty(props.value)
            ? "This field is required"
            : ""
        } // Message d'erreur
      >
        {renderOptions()}
      </TextField>
    </div>
  );
}

export default DropDownClientIdentifier;
